import { Component, Input, OnInit, Output, EventEmitter, Inject } from '@angular/core';
import { RoutePropertyController } from '@shared/src/controllers/route/properties/route.property.controller';
import { RoutePropertyDto } from '@shared/src/controllers/route/properties/RoutePropertyDto';
import { ActionDto } from '@shared/src/dtos/maintenance/action/actionDto';
import { ActionsStripDto } from '@shared/src/dtos/maintenance/action/ActionsStripDto';
import { SharedSaveButtonEvent } from '../../components.api';
import { HomeController, HString, SecurityController } from '@shared/src/public-api';
import { OpenRoutePropertyController } from '@shared/src/controllers/open/open.route.property.controller';
import { HLong } from '@shared/src/datatypes/HLong';
import { RoutePropertyChanged } from '@shared/src/controllers/route/properties/RoutePropertyChanged';



@Component({
  selector: 'shared-route-properties',
  templateUrl: 'shared.route.properties.component.html',
  styleUrls: ['./shared.route.properties.component.scss']
})
export class SharedRoutePropertiesComponent implements OnInit {

  public actions: ActionsStripDto;
  public searchText: string = "";

  constructor(@Inject('HomeController') public homeController: HomeController,
    @Inject('SecurityController') public securityController: SecurityController,
    private routePropertyController: RoutePropertyController, private openRoutePropertyController: OpenRoutePropertyController) {


    this.homeController.onRoutePropertiesChanged$.subscribe(data => {
      if (data && data.routeId == this.routeId) {
        this.getData();
      }
    });
  }

  public __uuid: string;
  @Input()
  public set uuid(value: string) {
    if (this.__uuid == value)
      return;
    this.__uuid = value;
    this.getData();
  }
  public get uuid(): string {
    return this.__uuid;
  }

  @Input()
  public driver: boolean = false;

  @Input()
  public exwork: boolean = false;

  @Input()
  public readonly: boolean = false;

  @Input()
  public linedtoslots: boolean;

  @Input()
  public pendingresponse: boolean;

  private _routeId: number;
  @Input() public set routeId(value: number) {
    if (this._routeId === value)
      return;
    this._routeId = value;
    this.getData();
  }
  public get routeId(): number {
    return this._routeId;
  }

  @Input()
  public phaseId: number;

  private _properties: Array<RoutePropertyDto>;
  public set properties(value: Array<RoutePropertyDto>) {
    if (this._properties === value)
      return;
    this._properties = value;
    this.loadRouteId();
  }
  public get properties(): Array<RoutePropertyDto> {
    return this._properties;
  }

  loadRouteId() {
    if (!HLong.isNullOrNullLong(this.routeId))
      return;

    if (this.properties == null)
      return;

    this.properties.forEach(element => {
      if (HLong.isNullOrNullLong(this._routeId) && !HLong.isNullOrNullLong(element.routeId))
        this._routeId = element.routeId;
    });
  }

  ngOnInit(): void {

    this.actions = new ActionsStripDto();
    this.actions.add(ActionDto.build("CALCULATE", "DESKTOP.SLOT.PICKER.COMPONENT.BUTTON.RELOAD", "", "fa-refresh", 10, 1, 1, "").actionGO());
    this.securityController.isHardManUser().subscribe(d => {
      if (d)
        this.actions.add(ActionDto.build("RESET", "DESKTOP.SLOT.PICKER.COMPONENT.BUTTON.RESET", "", "fa-eraser", 20, 1, 0, ""));
    });
  }

  getData() {
    if (this.exwork) {
      if(HString.isNullOrNullString(this.uuid))
        return;
      if (!this.driver) {
        if (!this.linedtoslots) {
          this.openRoutePropertyController.getExworkPropertiesByRouteId(this.uuid).subscribe(list => {
            this.properties = list;
          });
        } else {
          if (!this.pendingresponse) {
            this.openRoutePropertyController.getExworkPropertiesLinkedToSlotsByRouteId(this.uuid).subscribe(list => {
              this.properties = list;
            });
          } else {
            this.openRoutePropertyController.getExworkPropertiesLinkedToSlotsPendingResponseByRouteId(this.uuid).subscribe(list => {
              this.properties = list;
            });
          }
        }
      } else {
        if (!this.linedtoslots) {
          this.openRoutePropertyController.getDriverPropertiesByRouteId(this.uuid).subscribe(list => {
            this.properties = list;
          });
        } else {
          if (!this.pendingresponse) {
            this.openRoutePropertyController.getDriverPropertiesLinkedToSlotsByRouteId(this.uuid).subscribe(list => {
              this.properties = list;
            });
          } else {
            this.openRoutePropertyController.getDriverPropertiesLinkedToSlotsPendingResponseByRouteId(this.uuid).subscribe(list => {
              this.properties = list;
            });
          }
        }
      }
    } else {
      if(HLong.isNullOrNullLong(this._routeId))
        return;
      if (!this.linedtoslots) {
        this.routePropertyController.getPropertiesByRouteId(this._routeId).subscribe(list => {
          this.properties = list;
        });
      } else {
        if (!this.pendingresponse) {
          this.routePropertyController.getPropertiesLinkedToSlotsByRouteId(this._routeId).subscribe(list => {
            this.properties = list;
          });
        } else {
          this.routePropertyController.getPropertiesLinkedToSlotsPendingResponseByRouteId(this._routeId).subscribe(list => {
            this.properties = list;
          });
        }
      }
    }
  }

  @Output() public refresh: EventEmitter<RoutePropertyChanged> = new EventEmitter<RoutePropertyChanged>();
  onUpdateList(value: RoutePropertyDto) {
    if (value) {
      let findselected = false;
      let i = 0;
      while (i < this.properties.length) {
        if (this.properties[i].routePropertyId === value.routePropertyId) {
          this.properties[i] = value;
          findselected = true;
        }
        if (findselected) {
          i = this.properties.length;
        }
        i++;
      }
    }
  }

  public save($event: SharedSaveButtonEvent) {
    if(!HLong.isNullOrNullLong(this.phaseId)){

    }
    
    if (this.exwork) {
      if (!this.driver) {
        if(!HLong.isNullOrNullLong(this.phaseId)){
          this.openRoutePropertyController.setExworkValueListPhaseId(this.uuid, this.properties, this.phaseId).subscribe(data => {
            this.welcomeSetValue(data);
          });
        }else{
          this.openRoutePropertyController.setExworkValueList(this.uuid, this.properties).subscribe(data => {
            this.welcomeSetValue(data);
          });
        }
      } else {
        if(!HLong.isNullOrNullLong(this.phaseId)){
          this.openRoutePropertyController.setDriverValueListPhaseId(this.uuid, this.properties, this.phaseId).subscribe(data => {
            this.welcomeSetValue(data);
          });
        }else{
          this.openRoutePropertyController.setDriverValueList(this.uuid, this.properties).subscribe(data => {
            this.welcomeSetValue(data);
          });
        }
      }
    } else {
      if(!HLong.isNullOrNullLong(this.phaseId)){
        this.routePropertyController.setValueListPhaseId(this.properties, this.phaseId).subscribe(data => {
          this.welcomeSetValue(data);
        });
      }else{
           this.routePropertyController.setValueList(this.properties).subscribe(data => {
          this.welcomeSetValue(data);
        });
      }
    }
  }

  public _data: RoutePropertyChanged;
  welcomeSetValue(data: RoutePropertyChanged) {
    this._data = data;
    if (data) {
      this.refresh.next(data);
      if (!HLong.isNullOrNullLong(this.routeId))
        this.homeController.onRoutePropertiesChanged$.next(RoutePropertyChanged.setRouteId(data, this.routeId));
    }
  }

  public canSave() {
    if (!this.properties)
      return false;

    return true;
  }

  public onClickAction(action: ActionDto) {
    if (action == null)
      return;

    switch (action.actionId) {
      case "CALCULATE":
        if (this.exwork) {
          if (!this.driver) {
            this.openRoutePropertyController.exworkCompute(this.uuid).subscribe(data => {
              if (data)
                this.getData();
            });
          } else {
            this.openRoutePropertyController.driverCompute(this.uuid).subscribe(data => {
              if (data)
                this.getData();
            });
          }
        } else {
          this.routePropertyController.compute(this._routeId).subscribe(data => {
            if (data)
              this.getData();
          });
        }
        break;
      case "RESET":
        this.routePropertyController.reset(this._routeId).subscribe(data => {
          this.getData();
        });
    }
  }

  pretty(data) {
    return JSON.stringify(data);
  }

}

